<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-4">
        <h3>Levering</h3>
        <div id="updatedMessage" v-if="updated">
          <span class="message-info">Leveringsinnstillingene er oppdatert</span>
        </div>

        <div v-if="hasMultiLocations()" class="select-location-box mt-4">
          <span class="ingredient-title">For avdeling</span>
          <select class="form-select" v-model="locationId" @change="getDeliveryDocument()">
            <option v-for="(location, index) in locations" :key="index" :value="location.id">{{ location.name }}</option>
          </select>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <span class="bo_label">Minimums ordre</span>
            <div class="col-sm-2">
              <input class="form-control" type="number" v-model="minimumOrder" />
            </div>
          </div>
        </div>

        <span class="bo_label">Hvilke dager tilbyr dere levering?</span>
        <div class="opening-hours-flex-box">
          <div v-for="day in days" :key="day.key" class="delivery-days">
            <div>
              <span class="item-title">{{ day.label }}</span>
              <select class="deliveryOpenOrClose" v-model="dayData[day.key].status">
                <option value="open">Tilbyr levering</option>
                <option value="close">Tilbyr ikke levering</option>
              </select>
            </div>
            <div class="mt-3">
              <div>
                  <span class="time-label">Fra: </span>
                  <TimePicker
                    v-model="dayData[day.key].fromTime"
                    :disabled="dayData[day.key].status === 'close'"
                    :step-minutes="30"
                    :default-hour="10"
                    :default-minute="0"
                />
              </div>
              <div class="mt-3">
                  <span class="time-label">Til: </span>
                  <TimePicker
                  v-model="dayData[day.key].toTime"
                  :disabled="dayData[day.key].status === 'close'"
                  :step-minutes="30"
                  :default-hour="22"
                  :default-minute="0"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="bo_savebtn_container">
          <hr/>
          <button type="button" class="bo_btn" @click="save"> Lagre </button>
        </div>
      </div>
  </div>
</template>

<script>
import SettingsService from "@/services/settings/SettingsService";
import LoadingSpinner from "@/components/other/LoadingSpinner";
import TimePicker from "@/components/other/TimePicker";
import MerchantUtil from "@/util/MerchantUtil";
import LocationService from "@/services/location/LocationService";
import LocationUtil from "@/util/LocationUtil";

export default {
  components: { LoadingSpinner, TimePicker },
  data() {
    return {
      loading: true,
      locationId: '',
      locations: [],
      deliveryDocument: {},
      updated: false,
      minimumOrder: '',
      days: [
        { key: 'monday', label: 'Mandag', dayEnum: 'MONDAY', weekday: 1 },
        { key: 'tuesday', label: 'Tirsdag', dayEnum: 'TUESDAY', weekday: 2 },
        { key: 'wednesday', label: 'Onsdag', dayEnum: 'WEDNESDAY', weekday: 3 },
        { key: 'thursday', label: 'Torsdag', dayEnum: 'THURSDAY', weekday: 4 },
        { key: 'friday', label: 'Fredag', dayEnum: 'FRIDAY', weekday: 5 },
        { key: 'saturday', label: 'Lørdag', dayEnum: 'SATURDAY', weekday: 6 },
        { key: 'sunday', label: 'Søndag', dayEnum: 'SUNDAY', weekday: 7 }
      ],
      dayData: {
        monday: { status: 'close', fromTime: '', toTime: '' },
        tuesday: { status: 'close', fromTime: '', toTime: '' },
        wednesday: { status: 'close', fromTime: '', toTime: '' },
        thursday: { status: 'close', fromTime: '', toTime: '' },
        friday: { status: 'close', fromTime: '', toTime: '' },
        saturday: { status: 'close', fromTime: '', toTime: '' },
        sunday: { status: 'close', fromTime: '', toTime: '' }
      }
    };
  },
  mounted() {
    LocationService.listLocations().then(
      (response) => {
        this.locations = response.data;
        this.locationId = this.locations.length ? this.locations[0].id : '';
        this.getDeliveryDocument();
      },
      (error) => {
        console.log(error);
      }
    );
  },
  methods: {
    hasMultiLocations() {
      return LocationUtil.hasMultiLocations();
    },
    getDeliveryDocument() {
      this.loading = true;
      SettingsService.getDeliveryDocument(this.locationId).then(
        (response) => {
          if (response.data) {
            this.deliveryDocument = response.data;
          }
          this.initData();
          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    initData() {
      this.minimumOrder = this.deliveryDocument.minimumOrder || '';

      // Reset all days to closed
      for (const day of this.days) {
        this.dayData[day.key] = {
          status: 'close',
          fromTime: '',
          toTime: ''
        };
      }

      if (this.deliveryDocument && this.deliveryDocument.deliveryDays) {
        const deliveryDays = this.deliveryDocument.deliveryDays;

        for (const day of this.days) {
          const dayDelivery = this.getDeliveryDay(day.dayEnum, deliveryDays);
          if (dayDelivery != null) {
            this.dayData[day.key] = {
              status: 'open',
              fromTime: dayDelivery.fromTime || '',
              toTime: dayDelivery.toTime || ''
            };
          }
        }
      }
    },
    getDeliveryDay(day, deliveryDays) {
      if (deliveryDays) {
        for (let i = 0; i < deliveryDays.length; i++) {
          if (day === deliveryDays[i].day) {
            return deliveryDays[i];
          }
        }
      }
      return null;
    },
    getDeliveryDaysInputs() {
      const deliveryDays = [];

      for (const day of this.days) {
        if (this.dayData[day.key].status === 'open') {
          deliveryDays.push({
            day: day.dayEnum,
            weekday: day.weekday,
            fromTime: this.dayData[day.key].fromTime,
            toTime: this.dayData[day.key].toTime
          });
        }
      }

      return deliveryDays;
    },
    save() {
      this.loading = true;

      const deliveryDays = this.getDeliveryDaysInputs();

      if (JSON.stringify(this.deliveryDocument) === '{}') {
        // Blank object, CREATE
        this.deliveryDocument = {
          type: "delivery",
          merchant: MerchantUtil.getMerchant(),
          locationId: this.locationId,
          minimumOrder: this.minimumOrder,
          availableOnDays: ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"],
          deliveryDays: deliveryDays
        };
      } else {
        // UPDATE
        this.deliveryDocument.minimumOrder = this.minimumOrder;
        this.deliveryDocument.deliveryDays = deliveryDays;
      }

      SettingsService.editDeliveryDocument(this.deliveryDocument).then(
        (response) => {
          const documentId = response.data;
          if (documentId) {
            this.updated = true;
          } else {
            console.log("Editing delivery days failed");
          }
          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }
};
</script>
